const defaultDigits = 2;

// formats number to % string, e.g. 0.2456 with 2 digits precision to "20"
function numberToPercentage(number, digits = defaultDigits) {
  return Number.parseFloat(number * 100).toFixed(digits);
}

export default numberToPercentage;
